module.exports = __webpack_public_path__ + "static/media/error.f88d096e.jpg";